import {privateApi} from 'utils/api'

export const flightStatus = async (payload) => await privateApi.post('/cps/v1/flight-status', payload)

export const flightSchedule = async (payload) => await privateApi.post('/cps/v1/flight-schedule', payload)

export const shipmentHistory = async (payload) => await privateApi.post('/cps/v1/shipment-history', payload)
